import React, {Component} from 'react';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.less';
import {Provider} from 'react-redux'
import store from "./redux/reducer/FJRoot.reducer";
import {BrowserRouter, Route} from 'react-router-dom'
import FJMediaCacheStore from "./store/FJMediaCacheStore";
import FJLocalStore from './store/FJLocalStore'
import AppContent from './AppContent';
import FJConfig from "./config/FJConfig";
import {FJFontManager, FJFontArrayBufferManager} from "fj-graph";
import FJLoading from "./common/component/FJLoading/FJLoading";
import FJSaveStore from "./store/FJSaveStore";
import FJUtil from "./util/FJUtil";
import {FJSaveAction} from "./redux/action/FJRoot.action"
import $ from 'jquery'
import FJElementStore from "./store/FJElementStore";
import FJDecorationOverlayStore from "./store/FJDecorationOverlayStore";
import FJCloudStore from "./store/FJCloudStore";

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    }
  }

  componentDidMount() {
    (async () => {
      try {
        let prePromises = [];
        prePromises.push(FJElementStore.init());
        prePromises.push(FJMediaCacheStore.init());
        prePromises.push(FJDecorationOverlayStore.init());
        prePromises.push(FJLocalStore.init());
        prePromises.push(FJFontManager.init(`${FJConfig.fontPath}list.json`, FJConfig.fontPath));
        prePromises.push(FJFontArrayBufferManager.init(`${FJConfig.fontPath}fontName.json`));
        FJConfig.defaultFont.forEach((font) => {
          prePromises.push(new Promise((resolve) => {
            FJFontManager.loadDefaultFont(font, resolve);
          }));
        });
        await Promise.all(prePromises);
      } catch (e) {
        console.log(e);
      }

      if (document.getElementById('app-entry-loading')) {
        $('#app-entry-loading').remove();
      }

      this.setState({
        loading: false,
      }, () => {
        FJUtil.ealog('timeline_app page visit');
      });
    })();

    console.log(`buildVersion: ${FJConfig.buildVersion}`);
  };

  render() {

    return (
      this.state.loading ? <FJLoading isFull /> :
        <Provider store={store}>
          <BrowserRouter>
            <Route path='/'>
              <AppContent />
            </Route>
          </BrowserRouter>
        </Provider>
    );
  }
}

export default App;


/**
 * 头像下拉框退出选项钩子
 */
if (window.fjuser) {
  window.fjuser.addLogoutHook(() => {
    return new Promise((resolve, reject) => {
      store.dispatch(FJSaveAction.checkIsSaveAction((result) => {
        if (result) {
          resolve();
        } else {
          reject(new Error('logout error!'));
        }
      }));
    });
  });
}

/**
 * @description 页面跳转之前的判断
 * @returns {string}
 */
window.onbeforeunload = function () {

  let {SAVED} = FJSaveStore.SAVE_STATUS;
  if (SAVED !== FJSaveStore.status) {
    return "当前数据还没有保存，关闭或刷新窗口会自动保存数据，是否继续?";
  }

  const state = store.getState();
  const recording = state.recording;
  const cloud = state.cloud;
  if (recording.currentStage === 4 || recording.currentStage === 5) {
    return "当前数据还没有保存，关闭或刷新窗口会自动保存数据，是否继续?";
  }

  if (cloud.failed.length > 0 || FJCloudStore.getUploadingMedia()) {
    return "当前数据还没有保存，关闭或刷新窗口会自动保存数据，是否继续?";
  }
};
